import {inject, Injectable, signal} from '@angular/core';
import {Observable, tap} from 'rxjs';
import {RoleAssignApiService} from '../role-assign/role-assign-api.service';

@Injectable({providedIn: 'root'})
export class RoleInvitationService {
  private readonly api = inject(RoleAssignApiService);
  readonly pendingCount = signal<number>(0);

  refreshPendingCount(): Observable<{ count: number }> {
    return this.api.getPendingCount().pipe(
      tap((res) => {
        this.pendingCount.set(res?.count ?? 0);
      })
    );
  }
}
